<script>
    import NauiInput from "../../naui/atoms/NauiInput.svelte";
    import NauiSelect from "../../naui/atoms/NauiSelect.svelte";
    import UbicacionManejoVertical from "./UbicacionManejoVertical.svelte";
    import {hoursOptions} from "../../utils";

    export let data = {};
    export let origen = false;
    export let tipos_inmueble = [];

    let horas = hoursOptions;


</script>
<div class="grid-7-5 gap-3 mt-1 mb-2">
    <div>
        <div class="grid-3 gap-1 mb-ii">
            <NauiInput label="Ciudad {origen===true ? 'origen' : 'destino'}" bind:value="{data.ciudad}"/>
            <NauiSelect label="Tipo de inmueble" bind:value="{data.tipoInmueble}" options={tipos_inmueble}/>
            <NauiInput label="Piso" type="number" bind:value="{data.piso}"/>
        </div>
        <div>
            <NauiInput label="Dirección {origen===true ? 'origen' : 'destino'}" bind:value={data.direccion}/>
        </div>
        <div class="grid-1-2 gap-2 mt-2">
            <div>
                <h5 class="primary">Horarios permitidos</h5>
            </div>
            <div>
                <div class="grid-3 gap-1 mb-1">
                    <div class="box-r">
                        <p>L-V</p>
                    </div>
                    <NauiSelect label="Hora inicial" options="{horas}" icon="clock"
                                bind:value={data.horarios.semana.inicial}/>
                    <NauiSelect label="Hora límite" options="{horas}" icon="clock"
                                bind:value={data.horarios.semana.limite}/>
                </div>
                <div class="grid-3 gap-1">
                    <div class="box-r">
                        <p>S, D y Festivos</p>
                    </div>
                    <NauiSelect label="Hora inicial" options="{horas}" icon="clock"
                                bind:value={data.horarios.feriados.inicial}/>
                    <NauiSelect label="Hora límite" options="{horas}" icon="clock"
                                bind:value={data.horarios.feriados.limite}/>
                </div>
            </div>
        </div>
    </div>
    <div>
        <UbicacionManejoVertical bind:data="{data.vertical}"/>
    </div>

</div>
